import { IScheduleViewState } from './scheduleViewContext';
import { ScheduleViewActionTypes, TScheduleViewAction } from '../scheduleViewActions';

export const scheduleViewReducer = (state: IScheduleViewState, action: TScheduleViewAction): IScheduleViewState => {
	switch (action.type) {
		case ScheduleViewActionTypes.SET_SCHEDULED_PUSHES:
			return {
				...state,
				scheduledPushes: action.payload.scheduledPushes,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ScheduleViewActionTypes.REFETCH_SCHEDULES:
			return {
				...state,
				needRefetchSchedules: action.payload.needRefetchSchedules,
			};
		case ScheduleViewActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case ScheduleViewActionTypes.SET_STATUS:
			return {
				...state,
				status: action.payload.status,
				currentPage: 1,
			};
		case ScheduleViewActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
				currentPage: 1,
			};
		case ScheduleViewActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case ScheduleViewActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case ScheduleViewActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case ScheduleViewActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ScheduleViewActionTypes.SET_ID_FOR_EDIT:
			return {
				...state,
				IDForEdit: action.payload.IDForEdit,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ScheduleViewActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
